import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const MoreTimeRoundedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M10.75 8c-.41 0-.75.34-.75.75v4.69c0 .35.18.67.47.85l3.64 2.24c.33.2.76.11.97-.21.23-.34.12-.8-.23-1.01L11.5 13.3V8.75c0-.41-.34-.75-.75-.75z" />
      <path d="M17.92 12c.05.33.08.66.08 1 0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9 9-4 9-9c0-.34-.02-.67-.06-1h-2.02z" />
      <path d="M22 5h-2V3c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1z" />
    </SvgIcon>
  );
};

export default MoreTimeRoundedIcon;
